export const SUBCATS = [
  { key: "normal", label: "Normal" },
  { key: "newSibling", label: "New Sibling" },
  { key: "group", label: "Group" },
  { key: "referral", label: "Referral" },
  { key: "existingSibling", label: "Existing Sibling" },
];

export const START_MONTHS = ["February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const MONTH_NUM = { February: 2, March: 3, April: 4, May: 5, June: 6, July: 7, August: 8, September: 9, October: 10, November: 11, December: 12 };

export const INSTALMENT_LABELS = [
  "Instalment 1 (5th February)",
  "Instalment 2 (5th June)",
  "Instalment 3 (5th September)",
  "Instalment 4 (5th December)",
];

export const FEE_FIELDS = [
  { key: "admission_fee", label: "Admission Fee", group: "One-time Fees" },
  { key: "form_fee", label: "Form Fee", group: "One-time Fees" },
  { key: "tuition_fee", label: "Tuition Fee", group: "Annual School Fees" },
  { key: "term_fee", label: "Term Fee", group: "Annual School Fees" },
  { key: "casp_fee", label: "Cultural and Sports Programme (CASP)", group: "Annual School Fees" },
  { key: "adm_disc_pct", label: "Admission Fee Discount (%)", group: "Admission Fee Discounts", pct: true },
  { key: "spot_adm_disc", label: "On Spot Same day Admission fee Discount", group: "Admission Fee Discounts" },
  { key: "addl_adm_disc", label: "Additional Discount on Admission Fee", group: "Admission Fee Discounts" },
  { key: "referral_adm_disc", label: "Referral Discount on Admission fee", group: "Admission Fee Discounts" },
  { key: "existing_sibling_pct", label: "Existing Sibling Discount (% of Adm. Fee Discount)", group: "Admission Fee Discounts", pct: true },
  { key: "group_adm_disc", label: "Group of 3 or more parents (on Admission Fee)", group: "Admission Fee Discounts" },
  { key: "sibling_tuition_pct", label: "Sibling Discount (% on Tuition Fee)", group: "Tuition Fee Discounts", pct: true },
  { key: "spot_tuition_disc", label: "On Spot Same day Tuition fee Discount", group: "Tuition Fee Discounts" },
  { key: "referral_tuition_disc", label: "Referral Discount on Tuition fee", group: "Tuition Fee Discounts" },
];

export const inr = (n) =>
  n === "" ? "" : Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

const blank = (x) => (typeof x === "number" ? "" : Array.isArray(x) ? x.map(blank) : x && typeof x === "object" ? Object.fromEntries(Object.entries(x).map(([k, v]) => [k, k === "sr" ? v : blank(v)])) : x);
export const blankComputed = (c) => ({ ...blank(c), startMonth: c.startMonth, endMonth: c.endMonth });

// Replicates 'Final Sheet' formulas of the AY 2027-2028 workbook
export function computeReceipt(master, inputs) {
  const g = master?.[inputs.grade];
  const nurM = master?.["Nursery"];
  if (!g || !nurM) return null;
  const S = !!inputs.spot;
  const R = !!inputs.revisit;
  const { normal: N, newSibling: NS, group: G, referral: RF, existingSibling: ES } = inputs.sub || {};
  const isNur = inputs.grade === "Nursery";

  // Fee master derived rows
  const m14 = g.admission_fee * g.adm_disc_pct / 100;
  const m15 = g.spot_adm_disc, m16 = g.addl_adm_disc, m17 = g.referral_adm_disc;
  const m18 = m14 * g.existing_sibling_pct / 100, m19 = g.group_adm_disc;
  const L14 = nurM.admission_fee * nurM.adm_disc_pct / 100;
  const L23 = nurM.spot_tuition_disc;
  const m23 = g.spot_tuition_disc, m24 = g.referral_tuition_disc;

  const E20 = g.admission_fee, E21 = g.form_fee;
  const E24 = g.tuition_fee, E25 = g.term_fee, E26 = g.casp_fee;

  // J20: nested chain (nursery short-circuits) + independent revisit terms
  const chain = [
    [S && N, m14 + m15], [S && NS, m14 + m15 + m16], [S && ES, m14 + m18],
    [S && G, m14 + m19], [S && RF, m14 + m17], [R && N, m14 + m16],
  ];
  const nested = (i) => {
    if (i >= chain.length) return 0;
    const [c, x] = chain[i];
    if (c && isNur) return L14;
    return (c ? x : 0) + nested(i + 1);
  };
  const tail = [[R && NS, m14 + m16], [R && ES, m14 + m18], [R && G, m14 + m19], [R && RF, m14 + m17]]
    .reduce((s, [c, x]) => s + (c ? (isNur ? L14 : x) : 0), 0);
  const J20 = nested(0) + tail;

  // J24: tuition fee discount
  const sib = (g.sibling_tuition_pct / 100) * E24;
  let J24 = (S && NS ? sib : 0) + (R && NS ? sib : 0) + (R && ES ? sib : 0) + (R && RF ? m24 : 0);
  J24 += S && N && isNur ? L23 : (S && N ? m23 : 0) + (S && ES && isNur ? L23 + sib : S && ES ? m23 + sib : 0);
  J24 += S && G && isNur ? L23 : S && G ? m23 : 0;
  J24 += S && RF && isNur ? L23 : S && RF ? m23 + m24 : 0;

  const L20 = E20 - J20, L21 = E21, L22 = L20 + L21;
  const L24 = E24 - J24, L25 = E25, L26 = E26;
  const E27 = E24 + E25 + E26;
  const L27 = L24 + L25 + L26;

  const q = (E24 + E25 + E26) / 4;
  const quarterly = [q, q, q, q - J24];
  const startNum = MONTH_NUM[inputs.startMonth];
  const months = startNum ? 14 - startNum : 0;
  const monthly = months ? L27 / months : 0;

  return {
    grade: inputs.grade,
    rows1: [
      { sr: 1, desc: "Admission Fee", base: E20, discLabel: "Admission Fee Discount", disc: J20, final: L20 },
      { sr: 2, desc: "Form Fee", base: E21, discLabel: "", disc: null, final: L21 },
    ],
    oneTimeTotal: L22,
    rows2: [
      { sr: 1, desc: "Tuition Fee", base: E24, discLabel: "Tuition Fee Discount", disc: J24, final: L24 },
      { sr: 2, desc: "Term Fee", base: E25, discLabel: "", disc: null, final: L25 },
      { sr: 3, desc: "Cultural and Sports Programme (CASP)", base: E26, discLabel: "", disc: null, final: L26 },
    ],
    annualFee: E27,
    schoolFeeAfterDisc: L27,
    atAdmission: L22,
    quarterly,
    quarterlyTotal: quarterly.reduce((a, b) => a + b, 0),
    monthly,
    months,
    startMonth: inputs.startMonth,
    endMonth: "January",
    totalDiscount: J20 + J24,
  };
}
